const PartsModule = {
  namespaced: true,
  state: {
    data: []
  },
  mutations: {
    FETCH(state, payload) {
      state.data = []
      state.data = payload
    },
    DELETE: (state, payload) => {
      var index = state.data.findIndex(data => data.partsid === payload)
      state.data.splice(index, 1)
    },
    UPDATE: (state, payload) => {
      let index = state.data.findIndex(data => data.partsid === payload.partsid)
      state.data[index] = payload
    },
    INSERT: (state, payload) => {
      let index = state.data.findIndex(data => data.idx === payload.idx)
      state.data[index] = payload
    }
  },
  actions: {
    async fetch({ commit }) {
      try {
        const response = await axios.get(`/getParts`)
        commit('FETCH', response.data.PartsTHA)
      } catch (error) {
        throw new Error(error)
      }
    },
    async fetchByProductId({ commit }, payload) {
      try {
        const response = await axios.get(`/getPartsBy/productid/${payload}`)
        commit('FETCH', response.data)
      } catch (error) {
        throw new Error(error)
      }
    },
    async delete({ commit }, payload) {
      try {
        await axios.delete(`deleteParts/${payload}`)
        iziToast.info({
          title: 'Deleted!',
          position: 'bottomRight'
        })
        commit('DELETE', payload)
      } catch (error) {
        throw new Error(error)
      }
    },
    async update({ commit, dispatch }, payload) {
      try {
        const response = await axios.put(`/updateParts`, payload)
        if (response.data.message === true) {
          iziToast.info({
            title: 'Updated!',
            position: 'bottomRight'
          })
        }
        commit('UPDATE', payload)
      } catch (error) {
        throw new Error(error)
      }
    },
    async insert({ commit, dispatch }, payload) {
      try {
        const response = await axios.post(`/insertParts`, payload)
        if (response.data.message === true) {
          iziToast.success({
            title: 'Created!',
            position: 'bottomRight'
          })
          dispatch('fetch')
          commit('INSERT', payload)
        }
      } catch (error) {
        throw new Error(error)
      }
    }
  },
  getters: {
    getAll: state => {
      return state.data
    }
  }
}

export default PartsModule



// WEBPACK FOOTER //
// ./src/store/modules/parts/parts.js